const calculateDiscount = (oldPrice, price) => {
  if (
    oldPrice == null ||
    price == null ||
    isNaN(oldPrice) ||
    isNaN(price) ||
    oldPrice <= 0 ||
    price <= 0
  ) {
    return null;
  }

  if (oldPrice <= price) {
    return null;
  }

  const discount = ((oldPrice - price) / oldPrice) * 100;
  if (discount > 99) {
    return `${Math.floor(discount)}%`;
  }
  return `${Math.round(discount)}%`;
};

export default calculateDiscount;
